type FeatureFlag = string | boolean;

interface FeatureFlags {
  shipmentView: FeatureFlag;
  torderDelete: FeatureFlag;
  [key: string]: FeatureFlag;
}

export const decideFeatureFlags = (
  envVar: string | undefined,
): FeatureFlag => {
  if (!envVar || envVar === "false") {
    return false;
  }
  if (envVar === "true") {
    return true;
  }
  // If it's not "true" or "false", treat it as a comma-separated list of user IDs
  return envVar;
};

const featureFlags: FeatureFlags = {
  shipmentView: decideFeatureFlags(
    process.env.REACT_APP_FEATURE_SHIPMENT_VIEW,
  ),
  torderDelete: decideFeatureFlags(
    process.env.REACT_APP_FEATURE_TORDER_DELETE,
  ),
};

console.info("Feature Flags Configuration:", {
  rawEnvValue: process.env.REACT_APP_FEATURE_SHIPMENT_VIEW,
  userEnvValue: process.env.REACT_APP_FEATURE_SHIPMENT_VIEW_USERS,
  parsedFlags: featureFlags,
});

export const isFeatureEnabled = (
  featureName: keyof FeatureFlags,
  userId?: string,
): boolean => {
  const featureValue = featureFlags[featureName];

  // If feature is explicitly true, enable for everyone
  if (featureValue === true) {
    return true;
  }

  // If feature is false or undefined, disable for everyone
  if (featureValue === false || !featureValue) {
    return false;
  }

  // If feature is a string (user IDs), check if current user is in the list
  if (typeof featureValue === "string" && userId) {
    if (featureValue === "experiment") {
      // For legacy support: check if it's "experiment" mode
      const experimentUsers =
        process.env.REACT_APP_FEATURE_EXPERIMENT_USERS;
      return (
        experimentUsers &&
        experimentUsers
          .split(",")
          .map((user) => user.trim())
          .includes(userId.toString())
      );
    } else {
      // Regular user ID list
      const allowedUsers = featureValue
        .split(",")
        .map((user) => user.trim());
      return allowedUsers.includes(userId.toString());
    }
  }

  console.info("isFeatureEnabledLog", {
    featureFlags,
    featureName,
    userId,
    featureValue,
    result: false,
  });

  return false;
};
